module.exports = __webpack_public_path__ + "static/media/img_2.8cd36836.png";